window.Minus40ApiError = class Minus40ApiError
{
    status = 0;
    code = "";
    message = "";
    lineErrors = {};
    info= {};
}
